import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@store';
import ConfirmPopup from '../../components/user-list/confirm-popup/confirm-popup';
import { resetConfirmState } from './store/slices/confirm';
import { ColumnWithConfirmTypes } from './types';

const ColumnWithConfirmHOC = ({
  children,
  onSubmit,
  onCancel,
  globalError,
  editIsLoading,
}: ColumnWithConfirmTypes): React.JSX.Element => {
  const dispatch = useAppDispatch();

  const {
    confirm: { isLoading, popupIsOpen },
    users: { selectedUser },
    notificationSettings: { popupIsOpen: settingsPopupIsOpen },
  } = useAppSelector((state) => state.userList);

  useEffect(
    () => () => {
      dispatch(resetConfirmState());
    },
    [dispatch],
  );

  return (
    <>
      {children}
      {(popupIsOpen || settingsPopupIsOpen) && (
        <ConfirmPopup
          isLoading={isLoading}
          onSubmit={onSubmit}
          onCancel={onCancel}
          userName={`${selectedUser?.profile?.firstName || ''} ${
            selectedUser?.profile?.lastName || ''
          }`}
          globalError={globalError}
          editIsLoading={editIsLoading}
        />
      )}
      <div id="archive-popup" />
    </>
  );
};

export default ColumnWithConfirmHOC;
